<template>
  <div class="info-page">
    <div class="info-page-body flex">
      <div class="info-page-body-left flex-1">
        <p class="text">吕正操（1904年1月4日-2009年10月13日），原名吕正超，字必之。奉天省海城县（今辽宁省海城市）人。</p>
        <p class="text">8岁时在本村小学读书。1918年到缫丝厂当学徒。1922年参加东北军。1923年入东北讲武堂学习。毕业后，任东北军第五十三军连长、营长、少校副官队长，第一一六师参谋处长，六四七团、六九一团团长。1933年参加热河抗战。1936年组织“东北武装同志抗日救亡先锋队”，任总队长，参加“西安事变”。1937年5月加入中国共产党。</p>
        <p class="text">抗日战争爆发后，任冀中人民自卫军司令员，八路军第三纵队司令员，冀中军区司令员兼冀中行政公署主任，冀中区总指挥部副总指挥。1943的任晋绥军区司令员，中共中央晋绥分局委员。</p>
        <p class="text">中华人民共和国成立后，任中央人民政府铁道部副部长、代部长，中央军委军事运输司令员，解放军总参谋部军事交通部部长。 1955年被授予上将军衔。1964年任西南铁路建设总指挥部副总指挥、工地指挥部司令员兼政治委员和铁道兵第一政治委员。1965年任铁道部部长。1983年6月至1988年3月任政协全国委员会副主席。</p>
        <p class="text">2009年10月13日，中国共产党的优秀党员、久经考验的无产阶级革 命家吕正操同志在北京逝世，享年106岁。他是最后一位逝世的开国上将。</p>
      </div>
      <div class="info-page-body-right flex-shrink">
        <div class="info-page-body-right-top">
          <span class="info-page-body-right-top-img">
            <img src="@/assets/img/icon-lzc.png">
          </span>
          <span class="info-page-body-right-top-text">
            <p class="font-bold font-14 text-align-center tit">吕正操</p>
            <p class="font-12 text-align-center date">1904年1月4日-</p>
            <p class="font-12 text-align-center date">2009年10月13日</p>
          </span>
        </div>

        <div class="info-page-body-right-top cursor" @click="toBook">
          <span class="info-page-body-right-top-img">
            <img src="@/assets/img/icon-lzc-book.png">
          </span>
          <span class="info-page-body-right-top-text">
            <p class="font-bold font-14 text-align-center tit">主要著作</p>
            <p class="font-12 text-align-center date">《吕正操回忆录》</p>
          </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toBook() {
      this.$router.push({
        path: '/book',
        query: {
          cateId: '007004',
          sourceId: 21
        }
      })
    }
  }
}
</script>

<style scoped>
  .info-page-body {
    padding-top: 20px;
  }

  .info-page-body-right {
    width: 190px;
    margin-left: 30px;
  }

  .info-page-body-left .text {
    font-size: 16px;
    line-height: 32px;
    color: #3D3D3D;
    text-indent:2em;
    margin-bottom: 6px;
  }

  .info-page-body-right-top {
    border: 1px solid #EEEEEE;
    margin-bottom: 20px;
  }

  .info-page-body-right-top-img {
    padding: 15px;
    display: block;
  }

  .info-page-body-right-top-text {
    border-top: 1px solid #EEEEEE;
    display: block;
    padding: 10px;
  }

  .info-page-body-right-top-text .tit {
    line-height: 24px;
    margin-bottom: 4px;
  }

  .info-page-body-right-top-text .date {
    font-weight: 400;
    line-height: 18px;
  }
</style>
